import React from 'react';
import { IUser } from '../../../model/user/IUser';
import { Card, Table } from 'react-bootstrap';
import { ImpersonateEye } from '../../../shared/components/ImpersonateEye';
import TableSkeleton, { ITableColumn } from '../../../shared/components/TableSkeleton';
import { formatDate, getCorrectEnums } from '../../../utils/Functions';
import Flag from '../../../shared/components/Flag';

const USER_COLUMNS: ITableColumn[] = [
    { label: 'Display name' },
    { label: 'Type' },
    { label: 'Country' },
    { label: 'Joined', className: 'text-right' },
];

const SKELETON_ROWS = 10;

export function LatestUsersList({ users, isLoading = false }: { users: IUser[]; isLoading?: boolean }) {
    return (
        <Card className="p-4 mt-3 col-md-5-5 col-sm-12">
            <h5 className="p-3">Latest Users</h5>
            {isLoading ? (
                <TableSkeleton columns={USER_COLUMNS} rows={SKELETON_ROWS} />
            ) : (
                <Table hover responsive>
                    <thead>
                        <tr>
                            {USER_COLUMNS.map(column => (
                                <th key={column.label} className={column.className}>
                                    {column.label}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {users?.map(e => (
                            <tr key={e.id}>
                                <td className="align-items-center d-flex">
                                    <ImpersonateEye classes="py-0 h-15-px d-flex" id={e.id ?? 0} />
                                    {e.firstName}
                                </td>
                                <td>{getCorrectEnums(e?.userType)}</td>
                                <td>
                                    <Flag code={e?.contact?.country} />
                                </td>
                                <td className="text-right">{formatDate(e.createdAt)}</td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            )}
        </Card>
    );
}
